import {basePortalApi as api, CustomValues} from "../basePortalApi";
import {StateDto} from "../states/states-api";
import {
  PortalExecuteWorkflowCommandValuesDto,
  WorkflowExecutionResultDto,
} from "../workflowTriggers/workflowExecution-api";
import {toastError} from "../../common/utils/toastMessages";
import {t} from "i18next";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCities: build.mutation<CitiesGetApiResponse, CitiesGetApiArg>({
      query: (arg) => {
        const organizationId = process.env
          .REACT_APP_PORTAL_ORGANIZATION_ID as unknown as number;
        return {
          url: `/api/organizations/${organizationId}/workflowTriggers/${arg.workflowId}`,
          method: "POST",
          body: arg.values,
        };
      },
      async onQueryStarted(args, {queryFulfilled}) {
        try {
          await queryFulfilled;
        } catch (error) {
          toastError(t("toasts.serverError"));
        }
      },
    }),
  }),
  overrideExisting: false,
});
export {injectedRtkApi as portalApi};
export type CitiesGetApiResponse =
  /** status 200  */ WorkflowExecutionResultDto;
export type CitiesGetApiArg = {
  workflowId: string;
  values: PortalExecuteWorkflowCommandValuesDto;
};
export type CitiesGetValues = {
  countryCode: string;
  search: string;
};
export type CityDto = {
  organizationId?: number;
  cityId?: number;
  cityName: string;
  countryCode: string;
  countryName?: string | undefined;
  stateCode?: string | undefined;
  stateName?: string | undefined;
  state: StateDto;
  latitude?: number | undefined;
  longitude?: number | undefined;
  customValues?: CustomValues | null;
};
export const {useGetCitiesMutation} = injectedRtkApi;
